import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';

const UPDATE_DAILY_RATE = gql`
  mutation UpdateConsultantInvoiceDefaults_dailyRate($updatedInvoiceDefaults: UpdateConsultantInvoiceDefaultsRequestDto!) {
    updateConsultantInvoiceDefaults(updatedInvoiceDefaults: $updatedInvoiceDefaults) {
      dailyRateConsultantEur
      monthlyCommissionEur
      dailyCommissionEur
      manualCommission
    }
  }
`;

const UPDATE_COMMISSION = gql`
  mutation UpdateConsultantInvoiceDefaults_commission($updatedInvoiceDefaults: UpdateConsultantInvoiceDefaultsRequestDto!) {
    updateConsultantInvoiceDefaults(updatedInvoiceDefaults: $updatedInvoiceDefaults) {
      dailyRateConsultantEur
      monthlyCommissionEur
      dailyCommissionEur
      manualCommission
    }
  }
`;

export const useUpdateConsultantInvoiceDefaults = () => {

    const [updateDailyRate, { loading: loadingDailyRate, error: errorDailyRate, data: dataDailyRate }] = useMutation(UPDATE_DAILY_RATE);

    const [updateCommission, { loading: loadingCommission, error: errorCommission, data: dataCommission }] = useMutation(UPDATE_COMMISSION);

    return {
        updateDailyRate,
        updateCommission,
        loadingDailyRate,
        errorDailyRate,
        dataDailyRate,
        loadingCommission,
        errorCommission,
        dataCommission,
    };
};
